import { Body1 } from '@cian/ui-kit';

import * as styles from './AsideRow.css';

interface IAsideRowProps {
  title: string;
  content: React.ReactNode;
}

export const AsideRow = ({ title, content }: IAsideRowProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <Body1>{title}</Body1>
      </div>
      <div>{content}</div>
    </div>
  );
};
